import React from "react";
import SectionBlock from "../../../../global/components/FeatureCard/SectionBlock";
import partitionDiagram from "../../../../assets/images/partitionRole/partition-diagram.png";
import userRoleAuthorization from "../../../../assets/images/partitionRole/user-role-authorization.png";

const PAGE_X = "px-6 lg:px-[120px]";

const sections = [
  {
    image: partitionDiagram,
    label: "Advanced Schedule Management for Automated Access Control",
    description:
      "The Partition feature enables organizations to create isolated operational environments within a single access control infrastructure, supporting multi-site, multi-department, or multi-tenant deployments with complete data segregation. Each partition maintains separate access persons, credentials, doors, schedules, and event logs, ensuring complete privacy and operational independence between organizational units. The intuitive management interface allows administrators to create partitions with custom names, descriptions, and visual identifiers. Partitions are hierarchically organized with System Partition (0) as master control and Common Partition (1) for shared resources, eliminating the need for multiple separate systems while maintaining strict operational boundaries and reducing infrastructure costs.",
    imageLeft: true,
    imageBg: "#ffffff",
    textBg: "#f8f8f8",
    bodyColor: "#5b5b5b",
    imageMaxWidth: "590px",
    sectionHeight: "540px",
  },
  {
    image: userRoleAuthorization,
    label: "Granular User Role Authorization and Access Control",
    description:
      "The User Role feature delivers enterprise-grade permission management through configurable role-based access control (RBAC), allowing organizations to precisely define operator privileges across all system functions. Administrators create custom roles with granular page-level access permissions, determining which modules, configuration screens, and operational functions each operator can view, modify, or execute. Role definitions include hierarchical privilege levels from Administrator (highest authority) to custom operational roles with restricted access. Each role links to specific partitions, enabling operators to manage designated organizational segments while preventing unauthorized access to other areas. This sophisticated framework ensures compliance with security policies, maintains operational accountability, and protects sensitive functions while enabling efficient delegation of administrative responsibilities.",
    imageLeft: false,
    imageBg: "#ffffff",
    textBg: "#f8f8f8",
    bodyColor: "#5b5b5b",
    imageMaxWidth: "458px",
    sectionHeight: "640px",
    textAlign: "right",
  },
];

export const PartitionRoleManageContent = () => (
  <div className="bg-[#fcfcfc] w-full">
    <section
      className={`bg-white flex flex-col items-center justify-center gap-6 ${PAGE_X} pt-28 sm:pt-24 min-h-[258px] text-center`}
    >
      <h1 className="text-black text-[32px] font-medium font-['Inter'] leading-normal max-w-[1004px]">
        Partition & Role Management
      </h1>
      <p className="text-[#5b5b5b] text-[20px] font-medium font-['Poppins'] leading-normal max-w-[678px]">
        Centralized access governance with secure partitioning, granular
        permissions, and enterprise-grade operational control.
      </p>
    </section>

    <div className="w-full bg-white mt-6">
      {sections.map((section) => (
        <SectionBlock key={section.label} {...section} />
      ))}
    </div>
  </div>
);
